<template>
  <div class="bookings">
    <div class="py-5 bg-white w-100 flex items-center justify-center mt-5" style="height: 60vh" v-if="loading">
      <loader />
    </div>

    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table">
        <thead>
          <tr>
            <th class="width-xs">
              <base-checkbox v-model="shouldSelectAllBookings" />
            </th>
            <th v-for="header in activeHeaders" :key="header">{{ header.name }}</th>
            <!-- <th class="shipping-ref-col">SHIPPING REF. + DATE</th> -->
            <!-- <th>DISPATCHER</th>
            <th>FLEET TYPE</th>
            <th>SENDER</th>
            <th>RECEIVER</th>
            <th>SHIP FROM (ORIGIN)</th>
            <th>SHIP TO (DESTINATION)</th>
            <th>ORDER STATUS</th> -->
            <th class="width-xs">
              <svg @click="showFilterModal = true" class="cursor-pointer" width="18" height="18" viewBox="0 0 18 18"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51" />
                </g>
              </svg>
            </th>
          </tr>
        </thead>

        <tbody v-if="bookings.length">
          <tr v-for="booking in bookings" :key="booking.id">
            <td>
              <base-checkbox :value="booking.id" @change="$emit('newSelect', selectedBookings)"
                v-model="selectedBookings" />
            </td>

            <td v-for="header in activeHeaders" :key="header">
              <span v-if="header.name === 'ORDER STATUS'" class="capitalize text-base">
                <badge :class="colorSpec(booking.status)">{{
                  booking && booking.status.replace('-', " ")
                  }}</badge>
              </span>
              <span v-else-if=" header.name === 'DISPATCHER' ">
                {{ booking && booking.driver ? booking.driver.name : 'N/A' }}
                <abbr class="sub_abbr">{{ booking && booking.driver ? booking.driver.mobile_no : 'N/A' }}</abbr>
              </span>
              <span v-else-if=" header.name === 'FLEET TYPE' ">
                {{ booking && booking.fleet ? booking.fleet.type : 'N/A' }}
                <abbr class="sub_abbr">{{ booking && booking.fleet ? booking.fleet.number : 'N/A' }}</abbr>
              </span>
              <span v-else-if=" header.name === 'SHIPPING REF. + DATE'">
                <span>
                  {{
                  booking && booking.referenceNumber ? booking.referenceNumber : "N/A"
                  }}
                </span>
                <span class="block w-full opacity-50">
                  {{ booking.bookingDate | formatDate }}
                </span>
              </span>
              <span v-else>
                {{ getNestedValue(booking, headerMap[header.name]) }}
              </span>
            </td>

            <!-- <td> -->
              <!-- <span>
                {{
                booking && booking.referenceNumber ? booking.referenceNumber : "N/A"
                }}
              </span> -->
              <!-- <span>
                {{ booking.orderDate | formatDate }}
              </span> -->
              <!-- <span class="block w-full opacity-50">
                {{ booking.bookingDate | formatDate }}
              </span>
            </td> -->
            <!-- <td>
              {{ booking && booking.driver ? booking.driver.name : 'N/A' }}
              <abbr class="sub_abbr">{{ booking && booking.driver ? booking.driver.mobile_no : 'N/A' }}</abbr>
            </td>
            <td>
              {{ booking && booking.fleet ? booking.fleet.type : 'N/A' }}
              <abbr class="sub_abbr">{{ booking && booking.fleet ? booking.fleet.number : 'N/A' }}</abbr>
            </td>
            <td>
              {{ booking && booking.origin ? booking.origin.user.name : 'N/A' }}
            </td> -->
            <!-- <td>
              {{ booking && booking.destination ? booking.destination.user.name : 'N/A' }}
            </td>
            <td>
              {{ booking && booking.driver ? booking.origin.address : 'N/A' }}
            </td>
            <td>
              {{ booking && booking.driver ? booking.destination.address : 'N/A' }}
            </td> -->
            <!-- <td class="capitalize text-base">
              <badge :class="colorSpec(booking.status)">{{
                booking && booking.status.replace('-', " ")
                }}</badge>
            </td> -->
            <td class="ml-3 cursor-pointer relative" tabindex="-1">
              <el-dropdown>
                <button>
                  <vertical-ellipsis />
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <button @click="setTrips(booking)" class="flex items-center">
                      <details-icon />
                      <span class="ml-2">View Details</span>
                    </button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr class="custom-table">
            <td colspan="18">
              <div class="flex flex-col items-center gap-2 justify-center w-100">
                <empty-booking-icon />
                <p>No Bookings Currently</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="deleteModal" v-if="showDeleteModal == true">
      <div class="text-center modals-wrapper px-5 card" style="width: 500px">
        <img src="../../../../../assets/images/icons/confirm.svg" class="mx-auto" />
        <p class="mt-4 w-11/12 text-center">
          Are you sure you want to delete this Shipment?
        </p>
        <div class="flex flex-wrap justify-around py-4">
          <button class="border btn bg-transparent text-secondary" @click="cancelDelete">
            cancel
          </button>
          <button class="default-background btn" @click="deleteShipping">
            Delete
          </button>
        </div>
      </div>
    </div>

    <ViewDistination :activeTripView="activeTripView" :showModal="showViewDestinationModal"
      @close-modal="showViewDestinationModal = false" />

    <DDtableheaderfilter :show-modal="showFilterModal" :activeHeaders="activeHeaders"
      @close-modal="showFilterModal = false" />


  </div>
</template>

<script>
import ViewDistination from "../Modals/ViewDestination.vue";
import debounce from "@/utilities/debounce";
import DDtableheaderfilter from "../Modals/DDtableheaderfilter.vue";
// import DDtableheaderfilter from "../Modals/DDtableheaderfilter.vue";

export default {
  components: {
    DDtableheaderfilter,
    ViewDistination,
    // DDtableheaderfilter,
  },
  props: {
    loading: {
      required: true,
      type: Boolean,
    },
    currentTab: {
      default: "active",
    },
    queryString: {
      tyoe: String
    },
    pageSize: {
      type: Number || String
    },
    pageNumber: {
      type: Number || String
    },
    currentMethod: {
      default: "door-to-door-within"
    },
    setTotalBooking:{
      type: Function
    }
  },
  data() {
    return {
      showFilterModal: false,
      deleteId: "",
      showDeleteModal: false,
      confirmDelete: false,
      date: "",
      selectedBookingId: null,
      selectedBooking: {},
      selectedBookings: [],
      showReceiveShippingModal: false,
      showUpdateStatusModal: false,
      showPackageAndTagModal: false,
      showDeclineModal: false,
      showProcessHandoffModal: false,
      showAcceptModal: false,
      showCancelModal: false,
      showEditBookingModal: false,
      showProcessFulfillmentModal: false,
      showProcessReturnModal: false,
      showCreateReturnShipmentModal: false,
      showItemTrack: false,
      showShippingLabelModal: false,
      shouldSelectAllBookings: false,
      showUploadDocumentModal: false,
      showReceiptAcknoledgedModal: false,
      showActions: false,
      showFinCancelModal: false,
      selectedId: "",
      showConfirmFulfilment: false,
      showconfirmhandoffmodal: false,
      showRequestSentModal: false,
      showViewDestinationModal: false,
      processObj: {},
      messageId: "",
      bookings: [],
      activeTripView: {},
      center: [],
      activeHeaders: [
        { name: "SHIPPING REF. + DATE" },
        { name: "DISPATCHER" },
        { name: "FLEET TYPE" },
        { name: "SENDER" },
        { name: "RECEIVER" },
        { name: "SHIP FROM (ORIGIN)" },
        { name: "SHIP TO (DESTINATION)" },
        { name: "ORDER STATUS" },
      ],
      headerMap: {
        'SHIPPING REF. + DATE' : '',
        'DISPATCHER': '',
        'FLEET TYPE': '',
        'SENDER': 'origin.user.name',
        'RECEIVER': 'destination.user.name',
        'SHIP FROM (ORIGIN)': 'origin.address',
        'SHIP TO (DESTINATION)': 'destination.address',
        "ORDER STATUS": '',
        "Channel": 'bookingChannel',
        "Top distance": 'distance',
        "Load weight": 'loadWeight',
        "Income": 'tripCost'
      },
    };
  },
  watch: {
    queryString:debounce(function () {
      this.getDoorToDoorBooking()
    }, 500),
  currentTab() {
    this.getDoorToDoorBooking()
  },
  pageNumber() {
    this.getDoorToDoorBooking()
  },
  pageSize() {
    this.getDoorToDoorBooking()
  },
  isTableFilter() {
    let container = document.getElementById("table-wrapper");
    container.scrollLeft += 500;
  },
  shouldSelectAllBookings(val) {
    if (val) {
      this.bookings.forEach((booking) => {
        this.selectedBookings.push(booking.shipping.id);
      });
    } else {
      this.selectedBookings = [];
    }

    this.$emit('newSelect', this.selectedBookings)
  },
  sortTable() {
    this.bookings = this.toSort(
      this.bookings,
      "shippingReference",
      this.sortTable
    );
  },
},
computed: {
  bookigPayload(){
    return {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      status: this.currentTab,
      search: this.queryString
    }
  }
},
mounted() {
  this.getDoorToDoorBooking()
},
methods: {
  getNestedValue(obj, path) {
      const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
      return value === null || value === undefined || value === '' ? 'N/A' : value;
    },
  colorSpec(status) {
    switch (status) {
      case 'delivered':
        return "text-primary-green bg_green"
      case 'in-transit':
        return "text-primary-green bg_green"
      case 'accepted':
        return "text-primary-green bg_green"
      case "pending":
        return "text-primary-yellow bg_yellow"
      default:
        return "text-red-600 bg_red"
    }
  },
  setTrips(shipping) {
    this.center = [
      {
        lat: shipping?.origin?.lat || 0,
        lng: shipping?.origin?.lng || 0,
      },
      {
        lat: shipping?.destination?.lat || 0,
        lng: shipping?.destination?.long || 0,
      }
    ];
    this.activeTripView = shipping;
    this.showViewDestinationModal = true
  },
    async getDoorToDoorBooking() {
    this.loading = true
    try {
      console.log(this.bookigPayload)
      const response = await this.$_getDoorToDoorBooking(this.bookigPayload)
      this.bookings = response?.data?.data;
      this.setTotalBooking(response.data.meta.total)
    } catch (error) {
      this.handleError(error);
    } finally {
      this.loading = false
    }
  },
  refetchBooking() {
    this.$emit("refetchBookings");
  },

  returnItemsWeights(packageItems) {
    const packageWeights = [];
    packageItems.forEach((item) => {
      if (item.estimatedWeight) {
        packageWeights.push(item.estimatedWeight);
      }
    });
    const weight = packageWeights.join(", ");
    return weight ? weight : "N.A";
  },
  scrollLeft() {
    let container = document.getElementById("table-wrapper");
    container.scrollLeft += 10000;
  },
  actionCompleted() {
    this.scrollLeft();
    this.$emit("booking-action-completed");
  },
  toggleActions(id) {
    if (this.selectedBookingId) {
      this.selectedBookingId = null;
    } else {
      this.selectedBookingId = id;
    }
  },
},
};
</script>

<style lang="scss" scoped>
.bg_green {
  background-color: rgba(9, 183, 138, 0.1)
}

.bg_yellow {
  background-color: rgba(252, 194, 16, 0.1)
}

.bg_red {
  background-color: rgba(229, 62, 62, 0.1)
}

.sub_abbr {
  @apply opacity-50 text-sm font-normal block w-full;
}

.deleteModal {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  transform: scale(1.1);
  transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
}

.card {
  left: 40%;
  top: 40%;
}

.width-xs {
  min-width: 3rem !important;
}

#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 8px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}

.table-header {}

.custom-table {
  margin-top: 0;
}

th {
  min-width: 10rem;
  color: #19304d;
  opacity: 0.7;
  padding: 0.25rem;
  font-weight: normal;
}

.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}

td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 0.75rem 0.25rem;
  vertical-align: top;

  span {
    display: block;
  }

  // span:last-of-type {
  //   font-weight: normal;
  //   color: #10233e;
  //   opacity: 0.6;
  //   padding-top: 0.25rem;
  //   font-size: 0.8rem;
  // }
}

.booking-channel-col {
  width: 15%;
}

.shipping-ref-col {
  width: 13%;
}

.booking-status {
  background: #fae5e7;
  color: #d72638 !important;
  border-radius: 10px;
  padding: 0.5rem;
  font-weight: 500 !important;
  opacity: 1 !important;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.table-date {
  width: 12%;
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 0;
  right: 2rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 15rem;
  background: #ffffff;
  /* Stroke */
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }

  >div {
    display: flex;
    align-items: center;
    padding: 0.75rem;

    &:hover {
      background: rgb(225, 225, 225);
    }
  }

  .disabled {
    opacity: 0.5;

    &:hover {
      background: none;
    }
  }
}

.router {
  text-decoration: none !important;
  color: #84868b;
}

.router:hover {
  color: #fcc210;
}

.default-background {
  background-color: #fab427;
}
</style>
